export enum ReportStatusTypes {
  Active = 'active',
  Archived = 'archived',
  CompleteDraft = 'complete_draft',
  Countersigning = 'countersigning',
  Expired = 'expired',
  IncompleteDraft = 'incomplete_draft',
  MoveOutCompleteDraft = 'move_out_complete_draft',
  MoveOutCountersigning = 'move_out_countersigning',
  MoveOutExpired = 'move_out_expired',
  MoveOutIncompleteDraft = 'move_out_incomplete_draft',
  MoveOutSentForSigning = 'move_out_sent_for_signing',
  MoveOutSentCompleteDraft = 'move_out_sent_complete_draft',
  MoveOutSentIncompleteDraft = 'move_out_sent_incomplete_draft',
  MoveOutSignedByTenant = 'move_out_signed_by_tenant',
  MoveOutSigningCompleted = 'move_out_signing_completed',
  SentCompleteDraft = 'sent_complete_draft',
  SentForSigning = 'sent_for_signing',
  SentIncompleteDraft = 'sent_incomplete_draft',
  SignedByTenant = 'signed_by_tenant',
  SigningCompleted = 'signing_completed',
  TenantCompleteDraft = 'tenant_complete_draft',
  TenantIncompleteDraft = 'tenant_incomplete_draft',
  Terminated = 'terminated',
}

export const statusMap = {
  [ReportStatusTypes.Active]: 'Active',
  [ReportStatusTypes.CompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.Countersigning]: 'Countersigning',
  [ReportStatusTypes.Expired]: 'Expired',
  [ReportStatusTypes.IncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.MoveOutCountersigning]: 'Countersigning',
  [ReportStatusTypes.MoveOutExpired]: 'Expired',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutSentForSigning]: 'Signing In Progress',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'Signing In Progress',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'Signing Completed',
  [ReportStatusTypes.SentCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.SentForSigning]: 'Signing In Progress',
  [ReportStatusTypes.SentIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.SignedByTenant]: 'Signing In Progress',
  [ReportStatusTypes.SigningCompleted]: 'Signing Completed',
  [ReportStatusTypes.TenantCompleteDraft]: 'In Progress',
  [ReportStatusTypes.TenantIncompleteDraft]: 'In Progress',
  [ReportStatusTypes.Terminated]: 'Canceled',
};

export const participantStatusMap = {
  [ReportStatusTypes.Active]: 'Active',
  [ReportStatusTypes.CompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.Countersigning]: 'Countersigning',
  [ReportStatusTypes.Expired]: 'Expired',
  [ReportStatusTypes.IncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.MoveOutCountersigning]: 'Countersigning',
  [ReportStatusTypes.MoveOutExpired]: 'Expired',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutSentForSigning]: 'Signing In Progress',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'Signing In Progress',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'Signing Completed',
  [ReportStatusTypes.SentCompleteDraft]: 'Signing Canceled',
  [ReportStatusTypes.SentForSigning]: 'Signing In Progress',
  [ReportStatusTypes.SentIncompleteDraft]: 'Signing Canceled',
  [ReportStatusTypes.SignedByTenant]: 'Signing In Progress',
  [ReportStatusTypes.SigningCompleted]: 'Signing Completed',
  [ReportStatusTypes.TenantCompleteDraft]: 'Draft Completed',
  [ReportStatusTypes.TenantIncompleteDraft]: 'Draft Incomplete',
  [ReportStatusTypes.Terminated]: 'Canceled',
};

export type TagTone =
  | 'transparent'
  | 'success'
  | 'gray'
  | 'aqua'
  | 'blue'
  | 'green'
  | 'orange'
  | 'purple'
  | 'red'
  | 'teal'
  | 'yellow';

export const statusTagAppearanceMap: Record<ReportStatusTypes, TagTone> = {
  [ReportStatusTypes.Active]: 'green',
  [ReportStatusTypes.Archived]: 'gray',
  [ReportStatusTypes.CompleteDraft]: 'yellow',
  [ReportStatusTypes.Countersigning]: 'red',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCountersigning]: 'red',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSentForSigning]: 'blue',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'blue',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'yellow',
  [ReportStatusTypes.SentForSigning]: 'blue',
  [ReportStatusTypes.SentIncompleteDraft]: 'yellow',
  [ReportStatusTypes.SignedByTenant]: 'blue',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'blue',
  [ReportStatusTypes.TenantIncompleteDraft]: 'blue',
  [ReportStatusTypes.Terminated]: 'gray',
};

export const statusTagToneMap: Record<ReportStatusTypes, TagTone> = {
  [ReportStatusTypes.Active]: 'success',
  [ReportStatusTypes.Archived]: 'gray',
  [ReportStatusTypes.CompleteDraft]: 'yellow',
  [ReportStatusTypes.Countersigning]: 'red',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCountersigning]: 'red',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSentForSigning]: 'aqua',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'aqua',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'yellow',
  [ReportStatusTypes.SentForSigning]: 'aqua',
  [ReportStatusTypes.SentIncompleteDraft]: 'yellow',
  [ReportStatusTypes.SignedByTenant]: 'aqua',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'blue',
  [ReportStatusTypes.TenantIncompleteDraft]: 'blue',
  [ReportStatusTypes.Terminated]: 'gray',
};

export const participantStatusTagAppearanceMap: Record<ReportStatusTypes, TagTone> = {
  [ReportStatusTypes.Active]: 'success',
  [ReportStatusTypes.Archived]: 'gray',
  [ReportStatusTypes.CompleteDraft]: 'yellow',
  [ReportStatusTypes.Countersigning]: 'red',
  [ReportStatusTypes.Expired]: 'gray',
  [ReportStatusTypes.IncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutCountersigning]: 'red',
  [ReportStatusTypes.MoveOutExpired]: 'gray',
  [ReportStatusTypes.MoveOutSentForSigning]: 'aqua',
  [ReportStatusTypes.MoveOutSentCompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSentIncompleteDraft]: 'yellow',
  [ReportStatusTypes.MoveOutSignedByTenant]: 'aqua',
  [ReportStatusTypes.MoveOutSigningCompleted]: 'success',
  [ReportStatusTypes.SentCompleteDraft]: 'gray',
  [ReportStatusTypes.SentForSigning]: 'aqua',
  [ReportStatusTypes.SentIncompleteDraft]: 'gray',
  [ReportStatusTypes.SignedByTenant]: 'aqua',
  [ReportStatusTypes.SigningCompleted]: 'success',
  [ReportStatusTypes.TenantCompleteDraft]: 'yellow',
  [ReportStatusTypes.TenantIncompleteDraft]: 'yellow',
  [ReportStatusTypes.Terminated]: 'gray',
};
